import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import orderBy from 'lodash/orderBy'
import times from 'lodash/times'
import { Button } from 'transfix-ui/components/Button'
import { Skeleton } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Grid from 'transfix-ui/core/Grid'
import Typography from 'transfix-ui/core/Typography'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { SavedLaneCard } from 'apps/fleet-planner/components/saved-lanes/SavedLaneCard'
import { useSavedLanesContext } from 'apps/fleet-planner/context/SavedLanesContext'
import { AddIcon, RightArrowIcon } from 'transfix-icons'
import { SavedLanesCTA } from '../SavedLanesCTA'
import { useSavedLanesSectionStyles } from './useSavedLanesSectionStyles'

interface ISavedLanesSectionProps {}

export const SavedLanesSection: FC<ISavedLanesSectionProps> = () => {
  const classes = useSavedLanesSectionStyles()
  const { isMobile } = useBreakpointContext()
  const { loading: isLoading, savedLanes = [] } = useSavedLanesContext()
  const mostRecentSavedLanes = orderBy(savedLanes, 'createdAt', 'desc').slice(0, 3)
  const history = useHistory()

  const viewAllClickHandler = () => {
    history.push(`/transfix-lanes${history.location.search}`)
  }
  const addLaneClickHandler = () => {
    history.push(`/transfix-lanes/add-alert${history.location.search}`)
  }
  return (
    <div data-test='saved-lanes-section'>
      {!isLoading && savedLanes.length <= 0 && <SavedLanesCTA />}
      {!isLoading && savedLanes.length > 0 && (
        <Box display='flex' justifyContent='space-between' pb={2}>
          <div className={classes.title}>
            <Typography variant='h3'> Saved Lanes</Typography>
            <Button
              variant='text'
              color='tertiary'
              size='large'
              onClick={viewAllClickHandler}
              endIcon={<RightArrowIcon />}
              data-test='saved-lanes-view-all-link'>
              View All
            </Button>
          </div>
          {!isMobile && (
            <Button
              variant='text'
              color='tertiary'
              size='large'
              onClick={addLaneClickHandler}
              startIcon={<AddIcon />}
              data-test='saved-lanes-create-link'>
              Save New Lane
            </Button>
          )}
        </Box>
      )}
      {!isLoading && (
        <Grid container spacing={2}>
          {mostRecentSavedLanes.map(lane => (
            <Grid item lg={4} xs={12} key={lane.id} data-test='saved-lane-card-container'>
              <SavedLaneCard savedLane={lane} />
            </Grid>
          ))}
        </Grid>
      )}
      {isLoading && (
        <>
          <Box display='flex' justifyContent='space-between' alignItems='center' pb={2}>
            <div className={classes.title}>
              <Skeleton variant='rectangular' width='115px' height='27px' component='div' />
              <Box display='flex' alignItems='center' ml={1}>
                <Skeleton variant='rectangular' width='78px' height='19px' component='div' />
              </Box>
            </div>
            {!isMobile && (
              <Skeleton variant='rectangular' width='125px' height='19px' component='div' />
            )}
          </Box>
          <Grid container spacing={2}>
            {times(3).map(item => (
              <Grid key={item} item lg={4} xs={12}>
                <Skeleton variant='rectangular' height='105px' width='100%' component='div' />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  )
}

export default SavedLanesSection
